import { useClientSideTableFilter } from "~components/DataTable/hooks/useClientSideTableFilter.ts";
import type { ClientSideTableSearchField } from "~components/DataTable/types/clientSideTableSearchField.ts";
import { filterByTableField } from "~components/DataTable/utils/filterByTableField.ts";
import { CompetitionFilterTypes } from "~pages/Competitions/CompetitionsListPage/enums/competitionFilterTypes.ts";
import { CompetitionTableColumns } from "~pages/Competitions/CompetitionsListPage/enums/competitionTableColumns.ts";
import type { CompetitionTransformed } from "~pages/Competitions/types/competitionTransformed.ts";

const competitionSearchFields: Array<ClientSideTableSearchField<CompetitionTransformed>> = [
  CompetitionTableColumns.NameLocal,
  CompetitionTableColumns.AbbreviationLocal,
];

const competitionFilterFunctions = {
  [CompetitionFilterTypes.AgeGroup]: filterByTableField<CompetitionTransformed>(CompetitionTableColumns.AgeGroup),
  [CompetitionFilterTypes.League]: (competition: CompetitionTransformed, selectedValues: unknown[]) =>
    selectedValues.includes(competition.league?.leagueId),
};

type Props = {
  competitions: CompetitionTransformed[];
  currentFilter: Record<string, unknown>;
  searchText: string;
};

export const useFilteredCompetitions = ({ competitions, currentFilter, searchText }: Props): CompetitionTransformed[] => {
  const { filteredData } = useClientSideTableFilter({
    data: competitions,
    currentFilter,
    filterFunctions: competitionFilterFunctions,
    searchText,
    searchFields: competitionSearchFields,
  });

  return filteredData;
};
